export default __webpack_public_path__ + "static/media/pauseIcon.1aae1fee.svg";